import React from "react";
import { Fade } from "react-reveal";
import { useLanguage } from "../../context/LanguageContext";
import translations from "../../i18n/translations";
import "./Footer.css";
/* eslint-disable jsx-a11y/accessible-emoji */

export default function Footer(props) {
  const { lang } = useLanguage();
  const tGreeting = translations[lang].greeting;
  const tFooter = translations[lang].footer;

  return (
    <div className="footer-div">
      <Fade>
        <p className="footer-text" style={{ color: props.theme.secondaryText }}>
          {tFooter.madeWith}
          {tFooter.beforeAuthor}
          {tGreeting.fullName}
        </p>
      </Fade>
    </div>
  );
}
